import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { STRUCTURE_OPTIONS } from "@/lib/content";

export function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [preference, setPreference] = useState("les_deux");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const tid = compact ? "footer-newsletter" : "newsletter";

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Veuillez accepter la politique de protection des données.");
    setLoading(true);
    try {
      await api.post("/newsletter", { email, preference, consent });
      setDone(true);
      toast.success("Inscription confirmée");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) return <p className="mt-3 rounded-md bg-white/10 p-3 text-sm" data-testid={`${tid}-success`}>Merci, vous êtes inscrit(e) à la newsletter.</p>;
  const inputCls = compact ? "w-full rounded-md border border-white/20 bg-white/10 px-3 py-2.5 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-gold" : "input";
  return (
    <form onSubmit={submit} className="mt-3 space-y-2.5" data-testid={tid}>
      <label className="sr-only" htmlFor={`${tid}-email`}>E-mail</label>
      <input id={`${tid}-email`} type="email" required placeholder="Votre e-mail" className={inputCls} value={email}
        onChange={(e) => setEmail(e.target.value)} data-testid={`${tid}-email`} />
      <label className="sr-only" htmlFor={`${tid}-pref`}>Préférence</label>
      <select id={`${tid}-pref`} className={`${inputCls} ${compact ? "[&>option]:text-ink" : ""}`} value={preference}
        onChange={(e) => setPreference(e.target.value)} data-testid={`${tid}-preference`}>
        {STRUCTURE_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <label className={`flex items-start gap-2 text-xs ${compact ? "text-white/70" : "text-neutral-700"}`}>
        <input type="checkbox" className="mt-0.5 h-4 w-4 accent-[#E0A82E]" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid={`${tid}-consent`} />
        J'accepte de recevoir la newsletter et la politique de confidentialité.
      </label>
      <button type="submit" disabled={loading} className={compact ? "btn-gold w-full !py-2.5" : "btn-u"} data-testid={`${tid}-submit`}>
        {loading && <Loader2 className="h-4 w-4 animate-spin" />} S'inscrire
      </button>
    </form>
  );
}
